import React from "react";
import { HelpCircle } from "lucide-react";

/**
 * Graceful fallback for message types the UI doesn't (yet) render natively —
 * order, system, genuinely-unknown future Meta types, or Meta-flagged
 * `unsupported`. Shows a friendly label instead of a broken bubble, and never
 * crashes regardless of payload shape.
 */
const UnsupportedMessage = ({ message }) => {
  const original = message.metadata?.originalType;
  const errTitle = message.metadata?.errors?.[0]?.title;
  const label =
    errTitle ||
    message.content ||
    (original && original !== "unsupported"
      ? `Unsupported message (${original})`
      : "Unsupported message");

  return (
    <span className="wa-msg__unsupported" title="This message type isn't supported yet">
      <HelpCircle size={14} />
      {label}
    </span>
  );
};

export default UnsupportedMessage;
